













import { computed, defineComponent, inject, watch, ref } from '@vue/composition-api'
import TypeSelect from './TypeSelect.vue'
import Editor from '@/components/Editor.vue'
import { EntityType, ProjectFormType } from '@/api/project/model'
import { useEventBus } from '@/hooks/useEventBus'
import { UPDATE_BASIC_MESSAGE_ENTITY } from '@/config/event-bus'
import SettingBox from '@/components/SettingBox.vue'

export default defineComponent({
    components: {
        TypeSelect,
        Editor,
        SettingBox
    },
    setup(props, { emit }) {
        const { busEmit } = useEventBus()
        const itemObj: any = inject('itemObj')
        const onChange = () => {
            busEmit(UPDATE_BASIC_MESSAGE_ENTITY, itemObj)
        }
        const setIsCollapse = ref(true)

        watch(
            () => itemObj.message_entity.content,
            () => onChange()
        )

        return {
            ProjectFormType,
            EntityType,
            itemObj,
            setIsCollapse,
            onChange
        }
    }
})
